import Icon from '../Icon';
import { IconSpecificProps } from '../Icon.types';

const IconClose = ({ className, titleAccess }: IconSpecificProps) => (
  <Icon
    className={className}
    titleAccess={titleAccess}
    viewBox="0 0 24 24"
    fill="none"
    dataTestId="close-button">
    <path
      d="M20 4L4 20"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M4 4L20 20"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default IconClose;
